import { connectSortBy } from 'instantsearch.js/es/connectors'

const renderSortBy = (renderOptions, isFirstRender) => {
  const { options, refine, currentRefinement } = renderOptions;

  const sortbyElement = document.querySelector('#search-sortby');
  sortbyElement.innerHTML = `
    <ul class="c-section-nav__menu">
      ${options
        .map(
          option => `
            <li classs="c-section-nav__item">
              <a class="c-section-nav__link ${option.value === currentRefinement ? 'c-section-nav__link--current' : ''}" data-value="${option.value}">
                ${option.label}
              </a>
            </li>
          `
        )
        .join('')}
    </ul>
  `;
  sortbyElement.querySelectorAll('[data-value]').forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault()
      refine(element.dataset.value)
    })
  })
};

export default connectSortBy(
  renderSortBy
);
